import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import type { FunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../../redux/issuesV2';
import Flex from '../../../../generic/Flex';
import Checkbox from '../../../../generic/Forms/Checkbox';
import { useOpenIssueDrawer } from '../../../IssueDetails/Drawer/useOpenIssueDrawer';
import type { Issue } from '../../../../../../shared/issuesV2';

type BaseIssueItemProps = {
  id: number;
  issue: Issue;
};

/**
 * Represents the common/base layout for the IssueItem.
 * All of the different issue categories make use of this
 * common base issue item.
 */
const BaseIssueItem: FunctionComponent<BaseIssueItemProps> = ({ id, issue, children }) => {
  const dispatch = useDispatch();
  const isSelected = useSelector(IssuesV2Store.selectors.getIsIssueSelected(issue));
  const isComparisonModeOn = useSelector(IssuesV2Store.selectors.getComparisonMode);
  const openIssueDrawer = useOpenIssueDrawer(issue.id);
  const onTitleClick = () => openIssueDrawer();

  return (
    <button
      type="button"
      className={classNames('issue-item', 'clickable', { 'issue-item--extra-left-padding': isComparisonModeOn })}
      onClick={onTitleClick}
    >
      <div className="issue-item__container">
        {!isComparisonModeOn && (
          <Flex align="flex-start">
            <Checkbox
              isChecked={isSelected}
              onChange={() =>
                isSelected
                  ? dispatch(IssuesV2Store.actions.deselectIssue(id))
                  : dispatch(IssuesV2Store.actions.selectIssue(id))}
              shouldStopPropagation
              isRippleDisabled
            />
          </Flex>
        )}
        {children}
      </div>
    </button>
  );
};

export default BaseIssueItem;
